import React from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { getOrders, patchOrder } from "helpers/api_helper";
import moment from "moment";

const SendForPackagingModal = ({ isOpen, toggle, order, onStatusChanged }) => {
  const { t } = useTranslation();

const handleSendForPackaging = async () => {
  try {
    const payload = {
      resource: [{ id: order.id, status: "TO-PACKAGE" }],
    };

    await patchOrder(payload);
    console.log(t("Order") + ` ${order.id} ` + t("updated to TO-PACKAGE"));

    if (onStatusChanged) {
      // refresh the list in parent
      const res = await getOrders(true);
      const filtered = res
        .filter(ord =>
          ["PENDING-STOCK", "STOCK-OK", "TO-PACKAGE"].includes(ord.status)
        )
        .sort((a, b) =>
          moment(a.expected_delivery_date).diff(moment(b.expected_delivery_date))
        );
      onStatusChanged(filtered);
    }

    toggle();
  } catch (error) {
    console.error(t("Error updating order") + ` ${order.id}:`, error);
  }
};


  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {t("Send Order for Packaging")}
      </ModalHeader>
      <ModalBody className="text-center">
        <p>
          {t("Do you want to send this order")} <strong>{order?.id}</strong>{" "}
          {t("for packaging?")}
        </p>
        <Button color="success" size="lg" onClick={handleSendForPackaging}>
          {t("Send for Packaging")}
        </Button>
      </ModalBody>
    </Modal>
  );
};

SendForPackagingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  order: PropTypes.object,
  onStatusChanged: PropTypes.func
};

export default SendForPackagingModal;
